import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {MagazineService} from "../../../serverService/magazineService/MagazineService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {MagazineCategoryService} from "../../../serverService/magazineService/MagazineCategoryService";
import {MagazineCategoryParser} from "../../../pages/magazineCategory/MagazineCategoryParser";
import {
    RaikoBaseCardContainer,
    RaikoCategorySelect,
    RaikoGridOneColumn,
    RaikoSectionContainer, showErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function MagazineCategory({blogID}) {


    const serviceMagazine = new MagazineService()
    const serviceCategory = new MagazineCategoryService()
    const loadingHelper = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof blogID !== 'undefined') {
            setCategoryLoadingState(true)
            serviceCategory.getCategoryTree()
                .then(response => {
                    setCategoryItems(new MagazineCategoryParser(response).getCategoryListParsed())
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setCategoryLoadingState(false)
            })
            getSelectedCategory()
        }
    }, [blogID]);

    function getSelectedCategory() {
        serviceMagazine.getCategory(blogID)
            .then(response => {
                setSelectedCategoryItems([])
                setSelectionsTreeIds([])
                response.map((item, index) => {
                    setSelectedCategoryItems(prevState => [
                        ...prevState,
                        {
                            id: item.id,
                            name: item.title,
                            slug: item.slug
                        }
                    ])
                })


                response.map((item, index) => {
                    setSelectionsTreeIds(prevState => [
                        ...prevState,
                        item.id
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    const [categoryItems, setCategoryItems] = useState([]);
    const [categoryLoadingState, setCategoryLoadingState] = useState(false);
    const [selectedCategoryItems, setSelectedCategoryItems] = useState([]);
    const [selectionsTreeIds, setSelectionsTreeIds] = useState([]);

    function handleUpdateTourismCategory() {
        loadingHelper.show()
        serviceMagazine.updateCategory(blogID, selectedCategoryItems)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loadingHelper.hide()
        })
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"مدیریت دسته بندی ها"}
                subTitle={"برای افزودن دسته بندی جدید بر روی نام دسته بندی کلیک نمایید."}
                hasActionButton
                actionButtonOnclick={handleUpdateTourismCategory}
            >
                <RaikoGridOneColumn>
                    <RaikoCategorySelect
                        items={categoryItems}
                        loadingState={categoryLoadingState}
                        selectedCategoryItems={selectedCategoryItems}
                        setSelectedCategoryItems={setSelectedCategoryItems}
                        firstTreeSelectionsId={selectionsTreeIds}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}
